export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  highlight: string;
}

export const categories: Category[] = [
  {
    slug: "movie",
    name: "激情电影",
    description: "精选长片佳作，沉浸式剧情与细腻影像表达，带来完整的观影体验。",
    icon: "ri-film-line",
    highlight: "长片 · 90分钟以上",
  },
  {
    slug: "short",
    name: "激情短视频",
    description: "5-15分钟精品短片合集，一镜到底、高帧美学与强氛围感并存。",
    icon: "ri-play-circle-line",
    highlight: "短片 · 5-15分钟",
  },
  {
    slug: "theme",
    name: "热门主题",
    description: "按主题聚合精选片单，都市情感、海边夜色、实验叙事一网打尽。",
    icon: "ri-fire-line",
    highlight: "主题片单 · 持续更新",
  },
  {
    slug: "night",
    name: "夜色精选",
    description: "深夜场景的温柔与张力，霓虹、雨夜、末班车与便利店的故事。",
    icon: "ri-moon-line",
    highlight: "夜戏 · 精选",
  },
];

export const categoryTags: Record<string, string[]> = {
  movie: ["电影", "长片"],
  short: ["短视频", "短片"],
  theme: ["热门主题", "片单"],
  night: ["夜戏", "夜色"],
};

export interface FilterOption {
  value: string;
  label: string;
}

export const typeOptions: FilterOption[] = [
  { value: "movie", label: "电影" },
  { value: "short", label: "短视频" },
];

export const regionOptions: FilterOption[] = [
  { value: "中国大陆", label: "中国大陆" },
  { value: "中国香港", label: "中国香港" },
  { value: "中国台湾", label: "中国台湾" },
  { value: "韩国", label: "韩国" },
  { value: "日本", label: "日本" },
  { value: "泰国", label: "泰国" },
  { value: "法国", label: "法国" },
  { value: "意大利", label: "意大利" },
  { value: "英国", label: "英国" },
  { value: "西班牙", label: "西班牙" },
  { value: "德国", label: "德国" },
  { value: "阿根廷", label: "阿根廷" },
  { value: "新加坡", label: "新加坡" },
];

export const yearOptions: FilterOption[] = [
  { value: "2025", label: "2025" },
  { value: "2024", label: "2024" },
  { value: "2023", label: "2023" },
];

export const durationOptions: FilterOption[] = [
  { value: "0-10", label: "10分钟以内" },
  { value: "10-60", label: "10-60分钟" },
  { value: "60-110", label: "60-110分钟" },
  { value: "110+", label: "110分钟以上" },
];

export const sortOptions: FilterOption[] = [
  { value: "latest", label: "最新发布" },
  { value: "hot", label: "最热播放" },
  { value: "duration", label: "时长排序" },
  { value: "rating", label: "评分最高" },
];